module.exports = __webpack_public_path__ + "static/media/help.b256199b.svg";